import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Navbar } from "./components/Navbar";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import Feed from "./pages/Feed";
import PostErrand from "./pages/PostErrand";
import ErrandDetail from "./pages/ErrandDetail";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";
import Terms from "./pages/Terms";
import ForgotPassword from "./pages/ForgotPassword";
import GetVerified from "./pages/GetVerified";
import Pods from "./pages/Pods";
import PodDetail from "./pages/PodDetail";
import Services from "./pages/Services";
import { PaymentSuccess, PaymentCancel } from "./pages/Payment";

function Protected({ children, requireVerified = true, bare = false }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-[#6B7280]">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (requireVerified && !user.verified) return <Navigate to="/get-started" replace />;
  if (bare) return children;
  return (
    <>
      <Navbar />
      <div className="pb-24 md:pb-0">{children}</div>
    </>
  );
}

function PublicOnly({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-[#6B7280]">Loading…</div>;
  if (user) return <Navigate to="/feed" replace />;
  return children;
}

function App() {
  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get("code");
    if (code) sessionStorage.setItem("pendingPodCode", code.toUpperCase());
  }, []);
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PublicOnly><Landing /></PublicOnly>} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/login" element={<PublicOnly><Auth mode="login" /></PublicOnly>} />
            <Route path="/register" element={<PublicOnly><Auth mode="register" /></PublicOnly>} />
            <Route path="/forgot-password" element={<PublicOnly><ForgotPassword /></PublicOnly>} />
            <Route path="/get-started" element={<Protected requireVerified={false} bare><GetVerified /></Protected>} />
            <Route path="/pods" element={<Protected><Pods /></Protected>} />
            <Route path="/pods/:id" element={<Protected><PodDetail /></Protected>} />
            <Route path="/services" element={<Protected><Services /></Protected>} />
            <Route path="/feed" element={<Protected><Feed /></Protected>} />
            <Route path="/post" element={<Protected><PostErrand /></Protected>} />
            <Route path="/errand/:id" element={<Protected><ErrandDetail /></Protected>} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/profile/:id" element={<Protected><Profile /></Protected>} />
            <Route path="/admin" element={<Protected><Admin /></Protected>} />
            <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
            <Route path="/payment/cancel" element={<Protected><PaymentCancel /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
